import React from "react";
import QueryWithTwoOptions from "../shared/QueryWithTwoOptions";
import Contentify from "../../content/Contentify";
import Store from "./../../content/Store";
import { updateMakeAClaimProperties } from "../../actions/makeAClaim/MakeAClaimActions";
import { connect } from "react-redux";
import Scroll from "react-scroll";
import { DO_YOU_NEED_AUTHORISATION_CONTENT } from "./Constants";
import { SCROLL_TO_DETAIL_CONTAINER } from "../shared/containers/ScrollableDetailContainer";

export function AreYouThePatient(props) {
  return (
    <div>
      <QueryWithTwoOptions
        query={props.content.areYouThePatientQuestion}
        option1Label={props.content.areYouThePatientChoice1}
        option2Label={props.content.areYouThePatientChoice2}
        buttonType="transversalButton"
        option1OnClickHandler={() => {
          props.updateMakeAClaimProperties({
            isThePatient: true,
            isNewClaim: null
          });
          Scroll.scroller.scrollTo(SCROLL_TO_DETAIL_CONTAINER, {
            duration: 750,
            smooth: true
          });
        }}
        option2OnClickHandler={() => {
          props.updateMakeAClaimProperties({
            isThePatient: false,
            isNewClaim: null,
            authoriseTreatmentCondition: null
          });
          Scroll.scroller.scrollTo(DO_YOU_NEED_AUTHORISATION_CONTENT, {
            duration: 750,
            smooth: true
          });
        }}
        optionTwoIsSelected={
          typeof props.isThePatient === "boolean" ? !props.isThePatient : null
        }
      />
    </div>
  );
}

AreYouThePatient.content = Store.AreYouThePatient;

export const mapStateToAreYouThePatient = ({ makeAClaimReducer }) => {
  return {
    isThePatient: makeAClaimReducer.isThePatient,
    isNewClaim: makeAClaimReducer.isNewClaim,
    authoriseTreatmentCondition: makeAClaimReducer.authoriseTreatmentCondition
  };
};

export default connect(mapStateToAreYouThePatient, {
  updateMakeAClaimProperties
})(Contentify(AreYouThePatient));
